/**
 * The anonymous tally for one pushed item — bars, average ranks, or the words.
 * Shared by the plain item list and the slide deck so the projector shows the
 * same thing either way. No identity ever reaches this component: the backend
 * aggregates before it responds.
 */
export function LiveResponses({ responses }) {
  const maxCount = Math.max(1, ...(responses?.tally ?? []).map((t) => t.count));

  return (
    <>
      <p className="muted" aria-live="polite">
        {responses ? `${responses.total} response${responses.total === 1 ? '' : 's'}` : 'Waiting…'}
      </p>

      {responses?.mode === 'tally' && (
        <ul className="plain-list">
          {responses.tally.map((t) => (
            <li key={t.value} className="bar">
              <span className="bar__label">{t.label}</span>
              <span className="bar__track">
                <span className="bar__fill" style={{ width: `${(t.count / maxCount) * 100}%` }} />
              </span>
              <span className="bar__count">{t.count}</span>
            </li>
          ))}
        </ul>
      )}

      {responses?.mode === 'ranking' && (
        <ol className="plain-list">
          {responses.ranking.map((r) => (
            <li key={r.value}>
              <strong>{r.value}</strong>
              <span className="muted"> · average rank {r.average_rank}</span>
            </li>
          ))}
        </ol>
      )}

      {responses?.mode === 'responses' && (
        <ul className="quotes">
          {responses.responses.map((text, i) => (
            // Index key: these are anonymous strings with no id, and the list
            // only ever grows.
            // eslint-disable-next-line react/no-array-index-key
            <li key={i} className="quotes__item">
              “{text}”
            </li>
          ))}
          {responses.responses.length === 0 && <li className="muted">No answers yet.</li>}
        </ul>
      )}
    </>
  );
}

export default LiveResponses;
